export const FETCH_SELF_PSYCHOLOGIST = 'FETCH_SELF_PSYCHOLOGIST';
export const UPDATE_SELF_PSYCHOLOGIST = 'UPDATE_SELF_PSYCHOLOGIST';
export const FETCH_SELF_NUTRITIONIST = 'FETCH_SELF_NUTRITIONIST';
export const UPDATE_SELF_NUTRITIONIST = 'UPDATE_SELF_NUTRITIONIST';
